import { cn } from "@discovery/classnames";
import * as styles from "./styles.css";
import * as M from "@discovery/prelude/lib/data/maybe";
export var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["Outline"] = "outline";
    ButtonVariant["Rectangle"] = "rectangle";
    ButtonVariant["Primary"] = "primary";
    ButtonVariant["Disabled"] = "disabled";
})(ButtonVariant || (ButtonVariant = {}));
export const Button = ({ children, variant, id, disabledM = M.empty(), onClickM = M.empty(), customstyle, }) => (React.createElement("button", { className: cn(styles.button, customstyle, {
        [styles.viewAllButton]: variant === ButtonVariant.Outline,
        [styles.startButton]: variant === ButtonVariant.Rectangle,
        [styles.primaryButton]: variant === ButtonVariant.Primary,
        [styles.disabledButton]: variant === ButtonVariant.Disabled,
    }), disabled: M.fromMaybe(disabledM, false), onClick: M.fromMaybe(onClickM, undefined), id: id }, children));

